const jwt_customizer = {
    general: '在自訂 JWT 權杖時發生錯誤。請稍後再試。',
    can_not_create_for_admin_tenant: '無法為管理員租戶建立 JWT 權杖自訂程式。',
};
export default Object.freeze(jwt_customizer);
